// v2.17 (owner 2026-10-22, requirement 75 butir 9d): "Lapor masalah" — a station sends work back to an
// earlier one with a quick reason. Pure helpers (no imports) so Jest can test them; the server checks
// everything again.

export const LAINNYA = "LAINNYA";

// earlier stations a report can go back to (never QC), in workflow order; the default = the last one
export function posTujuanPilihan(steps, urutan) {
  return (steps || []).filter((s) => s.urutan < urutan && s.role !== "qc" && s.pos_code !== "QC");
}

const nama = (s) => s.pos_nama || s.pos_code;

// the stations that work again: from the target up to the reporter (the reporter last)
export function jalurUlang(steps, tujuan, urutan) {
  const t = Number(tujuan);
  const ulang = (steps || []).filter((s) => s.urutan >= t && s.urutan < urutan).map(nama);
  const pelapor = (steps || []).find((s) => s.urutan === urutan);
  return pelapor ? [...ulang, nama(pelapor)] : ulang;
}

// the error text of the form, or null
export function cekLapor({ alasan, keterangan, qty, maks, baris, perVariasi }) {
  if (!alasan) return "Pilih alasan (tombol cepat).";
  if (alasan === LAINNYA && (keterangan || "").trim().length < 5) return "Alasan \"Lainnya\": tulis keterangan (minimal 5 huruf).";
  const n = Number(qty);
  if (!Number.isInteger(n) || n < 1) return "Isi jumlah yang bermasalah, minimal 1.";
  if (maks && n > maks) return `Jumlah melebihi ${maks}.`;
  if ((baris || []).length > 1) {
    const total = Object.values(perVariasi || {}).reduce((a, v) => a + (Number(v) || 0), 0);
    if (total !== n) return `Jumlah per baris variasi harus ${n}.`;
  }
  return null;
}

// the reason as the server stores and reads it out: the label then the note; "Lainnya" = the note
export function teksAlasan(label, kode, keterangan) {
  const ket = (keterangan || "").trim();
  if (kode === LAINNYA) return ket;
  return ket ? `${label} — ${ket}` : label || "";
}

// the heading of a rework note: who sent it back (QC or a station's report)
export function asalRework(rw) {
  if (!rw) return "";
  if (rw.sumber === "POS") return `lapor masalah dari ${rw.pos_asal_nama || rw.pos_asal}`;
  return "reject QC";
}
